import React from 'react';
import { Col, Card, Row, Image, Container } from 'react-bootstrap';
import { motion } from 'framer-motion';
import familyPark from '../../assets/failyBusiness.jpg';
import headlineLogo from '../../assets/HLDlogo.webp';
import faceOffLogo from '../../assets/faceOffLogo.png';

const FamilyStory = () => {
	return (
		<div>
			<motion.section
				initial={{ opacity: 0, y: 50 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8 }}
				style={{
					minHeight: '100vh',
					display: 'flex',
					flexDirection: 'column',
					scrollSnapAlign: 'start',
					paddingTop: '2rem',
				}}>
				<Container className='d-flex flex-column h-100 justify-content-between px-3 px-md-5 bg-waterColorOrange'>
					<h1
						className='display-6 p-3 fw-bold mb-2 text-center '
						style={{ color: '#384971' }}>
						A Family Business
					</h1>
					<Row className='align-items-start justify-content-center'>
						<Col xs={12} md={5} className='mb-4 mb-md-0'>
							<Image
								src={familyPark}
								alt='Family Farm'
								fluid
								className='img-fluid rounded shadow'
								style={{
									width: '100%',
									height: 'auto',
									objectFit: 'cover',
								}}
							/>
						</Col>
						<Col xs={12} md={7}>
							<article>
								<p className='fs-6 text-start lh-base'>
									Grace and Anthony met and fell in love while
									singing at Ellen’s Stardust Diner — a
									beloved tourist destination in the heart of
									Times Square. From there, their shared love
									of music took them around the world:
									performing in theaters, arenas, concerts,
									cruise ships, piano bars, recordings, and
									cabarets.
								</p>
								<p className='fs-6 text-start lh-base'>
									Along the way, they studied improv together
									at New York City’s Face Off Unlimited and
									co-directed performances for The Copa Boys,
									working under the baton of conductor Michael
									Berkowitz.
								</p>
								<p className='fs-6 text-start lh-base'>
									In 2021, inspired by their close friends
									Andrew and Enrico — owners of Headline Dance
									Center — Grace and Anthony made the move to
									Minnesota. It was here they planted roots
									with their two sons, Archer and Andy, and
									built Color Your Voice into a creative home
									for young singers. What started as a passion
									project has grown into a thriving studio
									known for heartfelt teaching, strong
									community ties, and an unwavering dedication
									to helping young voices shine.
								</p>
								<p className='fs-6 text-start lh-base'>
									Over the last several years, Grace and
									Anthony have truly fallen in love with life
									in Minnesota. Teaching here has brought them
									immense joy — not just in helping students
									grow as singers, but in getting to know each
									child and their family along the way.
									Watching their students build confidence,
									express themselves, and grow into strong
									young people has been one of the greatest
									rewards of their journey.
								</p>
							</article>
						</Col>
					</Row>
					<div>
						<div className='mt-4 text-center pb-5'>
							<small className='text-muted'>Find out more:</small>
							<div className='d-flex justify-content-center gap-3 align-items-center mt-2'>
								<a
									href='https://www.faceoffunlimited.com/'
									target='_blank'
									rel='noreferrer'>
									<Image
										src={faceOffLogo}
										alt='Face Off Unlimited Logo'
										width='80'
										className='img-fluid'
									/>
								</a>
								<a
									href='https://www.headlinedancecenter.com/'
									target='_blank'
									rel='noreferrer'>
									<Image
										src={headlineLogo}
										alt='Headline Dance Center Logo'
										width='80'
										className='img-fluid'
									/>
								</a>
							</div>
						</div>
					</div>
				</Container>
			</motion.section>
		</div>
	);
};
export default FamilyStory;
